import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})

export class EnvironmentService {
  imgSrc: string;
  replayImgSrc: string;

  constructor() {
    const isEts = location.href.indexOf("/tripview.jsp") > -1 || location.href.indexOf("/master.jsp") > -1;
    this.imgSrc = isEts ? environment.assetPath : "";
    this.replayImgSrc = isEts ? environment.replayAssetPath : "";
  }

  getImgSrc(): string {
    return this.imgSrc;
  }

  getReplayImgSrc(): string {
    return this.replayImgSrc;
  }
}